<nb-card size="large">
    <nb-card-header>
        Site Selection        
    </nb-card-header>
    <nb-card-body>
        <div class="flex-wrap-row">
            <nb-card class="wrap-row-element" size="tiny"*ngFor="let site of sites" [ngStyle]="{'background':site?.color}">
                <nb-card-body>
                    <div class="site-card" (click)="selectSite(site)">
                        <div class="element-cnt">{{site?.siteName}}</div>
                        <div class="element-cnt theme-name">{{site?.themeName}}</div>
                        <div class="element-cnt title">{{site?.title}}</div>
                    </div>
                </nb-card-body>
            </nb-card>
        </div>
        <!-- <iframe src="http://localhost:4200/preview" #iframe (load)="onLoad(iframe)">
            
        </iframe> -->
    </nb-card-body>
    
</nb-card>

